/**
 * Ghost component
 * ---------------
 */

/* Imports */

import React from "react";
import { Ghost } from "./styles.module.scss";

/* Component */

const GhostComponent = ({ id = "", img = "" }) => {
  return (
    <div className={`${Ghost} lc-ghost`} id={id}>
      {img}
    </div>
  );
};

/* Export */

export default GhostComponent;
